module.exports = __webpack_public_path__ + "9bc1148a571253ea23c878022c11f720.png";